<template>
    <div>
        <p>
            Assess and analyse reserves on your entire book of claims. Perform predictive analysis to help with IBNR
            assessments. Changes in IBNR requirements following discount rate changes can be performed in seconds —
            even for 1000s of claims.
        </p>
        <p>
            Please select claims and two discount rates to compare Heads of Loss
        </p>

        <div v-if="individualClaim">
            <individual-search></individual-search>
        </div>
        <div v-else>
            <book-of-business-search></book-of-business-search>
        </div>

        <discount-rates></discount-rates>

        <button class="a-button a-button--small" @click="compare()" :disabled="disableCompare">Compare</button>
        <button class="a-button a-button--small" @click="reset()">Reset</button>

        <div v-if="loading && results.count === undefined" class="a-loader--results"></div>

        <div v-if="results.count > 0" style="margin: 20px 0 40px;">
            Discount Rate Comparison based on {{ results.count }} matching claims.
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import BookOfBusinessSearch from 'pages/discount-rate-comparison/components/form/BookOfBusinessSearch.vue';
    import DiscountRates from 'pages/discount-rate-comparison/components/form/DiscountRates.vue';
    import IndividualSearch from 'pages/discount-rate-comparison/components/form/IndividualSearch.vue';

    export default {
        name: 'page-form',
        components: {
            BookOfBusinessSearch,
            DiscountRates,
            IndividualSearch,
        },
        computed: {
            ...mapState('discountRateComparison', [
                'chosenRates',
                'results',
                'loading'
            ]),
            ...mapGetters('discountRateComparison', [
                'individualClaim',
            ]),
            disableCompare: {
                get() {
                    return !this.chosenRates.length;
                },
            },
        },
        methods: {
            ...mapActions('discountRateComparison', [
                'compare',
                'reset',
            ]),
        },
    }
</script>



// WEBPACK FOOTER //
// PageForm.vue?4855962e